import { createFileRoute } from '@tanstack/react-router'
import { PromotionsContainer } from '@/features/promotions'

export const Route = createFileRoute('/$store/_layout/promotions')({
  component: PromotionsPage,
})

function PromotionsPage() {
  return <PromotionsContainer />
}
